var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMenuMobile = function SvgIconMenuMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.609,
    height: 24.61
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M12.412 0H2.192a2.2 2.2 0 0 0-2.2 2.2v20.214a2.2 2.2 0 0 0 2.2 2.2h10.22a2.2 2.2 0 0 0 2.2-2.2V2.197a2.2 2.2 0 0 0-2.2-2.2ZM10.54.961l-.436 1.341h-5.6L4.068.961Zm3.107 21.452a1.236 1.236 0 0 1-1.235 1.235H2.192a1.236 1.236 0 0 1-1.235-1.235V2.196A1.236 1.236 0 0 1 2.192.964h.861l.64 1.97a.48.48 0 0 0 .457.332h6.3a.48.48 0 0 0 .457-.332l.64-1.97h.861a1.236 1.236 0 0 1 1.235 1.235v20.214Zm-6.343-3.378a1.713 1.713 0 1 0 1.713 1.713 1.714 1.714 0 0 0-1.713-1.712Zm0 2.463a.751.751 0 1 1 .751-.751.75.75 0 0 1-.751.752Z",
    "data-name": "Path 5785"
  })));
};
export default SvgIconMenuMobile;